module.exports = __webpack_public_path__ + "13d3221ddf329035357dde967f73462d.svg";